export default {
  'Animate old photos': 'Animasikan foto lama',
  'Animate faces in your photos with AI technology, create vivid videos.':
    'Animasikan wajah di foto Anda dengan teknologi AI, buat video yang hidup.',
  'Upload a photo': 'Unggah foto',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    'Catatan: tolong pastikan wajah dalam foto yang Anda pilih menghadap lensa, jika tidak maka tidak akan berhasil diproses.',
  'Uploaded successfully!': 'Berhasil diunggah!',
  'Please select a template below': 'Silahkan pilih template di bawah ini',
  'Choose a GIF': 'Pilih GIF',
  'Use this template': 'Gunakan template ini',
  'Verify successfully! You will':
    'Verifikasi berhasil! Anda akan segera menerima video di {{email}}.',
  'You will': 'Anda akan segera menerima video di {{email}}.',
  'What you should expect to happen next': 'Apa yang akan terjadi selanjutnya:',
  'We will process your photo into a dynamic video.':
    'Kami akan memproses foto Anda menjadi video dinamis.',
  'After processing, we will send the video to your email.':
    'Setelah diproses, video akan kami kirimkan ke email Anda.',
  'You can check the video in your email.':
    'Anda dapat memeriksa video di email Anda.',
  'Your video will be delivered via email':
    'Video Anda akan dikirim melalui email',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    'Diperlukan waktu 20-30 menit untuk membuat video dinamis, silahkan tunggu. Untuk melindungi privasi Anda, gambar yang diunggah akan otomatis dihapus setelah pemrosesan selesai.',
  'Your Email': 'Email Anda',
  'Last Name': 'Nama Depan',
  'First Name': 'Nama Belakang',
  'Go back': 'Kembali',
  'Invalid email address': 'Alamat email tidak valid',
  'Enter verification code': 'Masukkan kode verifikasi',
  'Enter the verification code that we sent to':
    'Masukkan kode verifikasi yang kami kirim ke {{email}}.',
  Resend: 'Kirim Ulang',
  'Verification code': 'Kode verifikasi',
  'Resend after': 'Kirim ulang setelah {{num}}d',
  'The verification code is invalid. You can request a new one.':
    'Kode verifikasi tidak valid. Anda dapat meminta yang baru.',
  'Synthesize Video': 'Membuat Video',
  Next: 'Berikutnya',
  'Too many attempts, please try again later.':
    'Terlalu banyak percobaan, tolong coba lagi nanti.',
  'xx people is waitting in front of you to generate image.':
    ' creators ahead of you, please wait...',
  'Animating...': 'Animating...',
  'You are in line...': 'You are in line...',
  'Failed to generate, click to retry.': 'Failed to generate, click to retry.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'The processing will be completed soon, are you sure you want to cancel it?',
  freeAccountExceed: 'The image size cannot exceed 2MB in free version.',
  freeAccountHD: 'Upgrade to download HD watermark-free images.',
  UpgradeToDownloadAsGIF: 'Upgrade to download video as GIF.',
  UpgradeToUploadLimits: 'Upgrade to unlimited image uploads.',
  DynamicTitle: 'HitPaw Online Animate Old Photos',
  SizeLimit: 'No Image Size Limits',
  UploadLimit: 'Unlimited Image Uploads',
  DownloadNoWaterMark: 'Download HD Image with No Watermark',
  DownloadGIF: 'Download Video as GIF',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  Week: 'Week',
  billMonth: '$7.99 Billed Monthly',
  billYear: '$47.99 Billed Annually',
};
